// Generated by ReScript, PLEASE EDIT WITH CARE

import * as DragPreview17BindJs from "./DragPreview17.bind.js";

var make = DragPreview17BindJs.Preview;

export {
  make ,
  
}
/* make Not a pure module */
